// extracted by mini-css-extract-plugin
export var layoutContainer = "_7b-0";
export var layoutContainerNoRounding = "_7b-6";
export var layoutContainerOpen = "_7b-5";
export var layoutContainerResizing = "_7b-1";
export var mainContent = "_7b-2";
export var resizeDivider = "_7b-3";
export var slidePanel = "_7b-4";